import practiceUsers from "@/components/practice/PracticeUsers";
import practiceUserList from "@/components/practice/UserList";
import practiceUserEdit from "@/components/practice/UserEdit";
import practiceUserCreate from "@/components/practice/UserCreate";

export default {
  path: "/user-list",
  component: practiceUsers,
  meta: {
    permission: "practice:update|practice:manage|user:manage"
  },
  children: [
    {
      path: ":id",
      name: "user-list",
      component: practiceUserList,
      props: true,
      meta: {
        title: "User List",
        permission: "practice:update|practice:manage|user:manage"
      }
    },
    {
      path: ":id/user/:userId",
      name: "user-edit",
      component: practiceUserEdit,
      props: true,
      meta: {
        title: "Practice User Edit",
        permission: "practice:update|practice:manage|user:manage"
      }
    },
    {
      path: ":id/user/new",
      name: "user-create",
      component: practiceUserCreate,
      props: true,
      meta: {
        title: "Practice User Create",
        permission: "practice:update|practice:manage|user:manage"
      }
    }
  ]
};
